import React from "react";
import { empty } from "../../functions";
import "./ltextarea.css";
export interface ILTextarea {
  legendText?: string;
  placeholder?: string;
  noLegend?: boolean;
  val: string;
  setVal?: React.Dispatch<React.SetStateAction<string>> | null;
  readonly?: boolean;
  hidden?: boolean;
  bgROColor?: string;
  minWidth?: string;
  rows?: number;
}
export const LTextarea = ({
  val,
  setVal = null,
  readonly = false,
  hidden = false,
  noLegend = false,
  legendText = "",
  placeholder = "",
  bgROColor = "#e9ecef",
  minWidth = "380px",
  rows = 6,
}: ILTextarea) => {
  const onSetVal = (v: string) => {
    if (setVal != null) setVal(v);
  };
  return (
    <fieldset
      hidden={hidden}
      className="ltextarea-fieldset"
      style={{ background: readonly ? bgROColor : "white" }}
    >
      <legend hidden={noLegend || empty(val)} className="ltextarea-legend">
        {legendText}
      </legend>
      <textarea
        readOnly={readonly}
        onChange={(e) => onSetVal(e.target.value)}
        className="ltextarea-textarea"
        placeholder={placeholder}
        rows={rows}
        value={val}
        style={{ minWidth: minWidth }}
      ></textarea>
    </fieldset>
  );
};
